import { createContext, useState } from "react";

export const DeviceContext = createContext();
const DeviceProvider = ({children}) =>{
    const [selectedTenantAdminProfile,setSelectedTenantAdminProfile] = useState(null);
    const [selectedDevice,setSelectedDevice] = useState(null);
    return(
        <DeviceContext.Provider value={{
            selectedTenantAdminProfile,setSelectedTenantAdminProfile,
            selectedDevice,setSelectedDevice
        }}>{children}</DeviceContext.Provider>
    );
};
export default DeviceProvider;